import React, { useRef, useState } from 'react';
import { toast } from 'react-toastify';
import recallService from '../../../../services/recall.service';
import { showError } from '../../../../utils/ecxSwal';
import { isAllowedRecallFile, RECALL_ALLOWED_EXTENSIONS } from './recallsQuery';

function RecallUploadButton({
    clinicId,
    recallId,
    onUploaded,
    disabled = false,
    variant = 'outline-primary',
    label = 'Upload file',
    showLabel = false,
}) {
    const fileInputRef = useRef(null);
    const [uploading, setUploading] = useState(false);

    const handleFileChange = async (event) => {
        const file = event.target.files?.[0];

        if (!file || !clinicId || !recallId) {
            return;
        }

        if (!isAllowedRecallFile(file)) {
            showError({
                title: 'Invalid file',
                text: `Allowed file types: ${RECALL_ALLOWED_EXTENSIONS.join(', ')}`,
            });
            event.target.value = '';
            return;
        }

        setUploading(true);

        try {
            await recallService.uploadRecallFiles(clinicId, recallId, file);
            toast.success('Recall file uploaded');
            onUploaded?.();
        } catch (error) {
            console.error('Failed to upload recall file', error);
            showError({
                title: 'Upload failed',
                text: error?.response?.data?.message || 'Unable to upload recall file. Please try again.',
            });
        } finally {
            setUploading(false);
            event.target.value = '';
        }
    };

    return (
        <>
            <input
                ref={fileInputRef}
                type="file"
                className="d-none"
                accept=".csv,.doc,.docx,.pdf"
                onChange={handleFileChange}
            />
            <button
                type="button"
                className={`btn btn-${variant} btn-sm rounded-pill`}
                onClick={() => fileInputRef.current?.click()}
                disabled={disabled || uploading}
                title="Upload recall file"
            >
                {uploading ? (
                    <>
                        <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
                        Uploading...
                    </>
                ) : (
                    <>
                        <i className="bi bi-upload me-1"></i>
                        {showLabel ? label : null}
                        {!showLabel && <span className="visually-hidden">{label}</span>}
                    </>
                )}
            </button>
        </>
    );
}

export default RecallUploadButton;
